import React, { useEffect, useState } from 'react'
import CarouselGallery from '../CarouselGallery'
import GalleryAllScreen from '../GalleryAllScreen'

const CarouselGalleryApp = ({ items, ...props }) => {
  const [showGalleryAllScreen, setShowGalleryAllScreen] = useState(false)
  const [initialSlideGalleryAllScreen, setInitialSlideGalleryAllScreen] =
    useState(0)

  useEffect(() => {
    if (showGalleryAllScreen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [showGalleryAllScreen])

  const handleItemClick = ({ image }) => {
    setShowGalleryAllScreen(true)
    const indexActive = getActiveGalleryAllScreen(items, image)
    setInitialSlideGalleryAllScreen(indexActive > -1 ? indexActive : 0)
  }

  const handleGalleryAllScreenClose = () => {
    setShowGalleryAllScreen(false)
  }

  /**
   * Retorna o index da galeria ativa
   * @param {Array} items
   * @param {String} image
   * @returns {Number}
   */
  const getActiveGalleryAllScreen = (items, image) => {
    return items.findIndex((item) => item.image.small_webp.url === image)
  }

  return (
    <>
      <CarouselGallery items={items} {...props} onItemClick={handleItemClick} />
      {showGalleryAllScreen && (
        <GalleryAllScreen items={items} onClose={handleGalleryAllScreenClose} />
      )}
    </>
  )
}

export default CarouselGalleryApp
